import { classnames } from 'helpers/utils';
import styles from './user-initials.module.scss';

export interface UserInitialsProps {
  name: string;
  innerClassName?: string;
}

interface ColorMap {
  [key: string]: string;
}

const UserInitials: React.FC<UserInitialsProps> = ({
  name,
  innerClassName = '',
}) => {
  const backgroundColors = ['#ebf5fa', '#ebf4f3', '#fcf4ea', '#faf7e9'];

  const textColorMap: ColorMap = {
    '#ebf5fa': '#1b9fd8',
    '#ebf4f3': '#1d8c7f',
    '#fcf4ea': '#eb870e',
    '#faf7e9': '#d6b100',
  };

  const colorIndex = name ? name.length % backgroundColors.length : 0;
  const selectedBackgroundColor = backgroundColors[colorIndex];
  const selectedTextColor = textColorMap[selectedBackgroundColor];

  return (
    <div
      className={classnames(styles.containerName, innerClassName)}
      style={{ backgroundColor: selectedBackgroundColor }}
    >
      <div
        className="text__body__regular__medium__info60"
        style={{ color: selectedTextColor }}
      >
        {name}
      </div>
    </div>
  );
};

export { UserInitials };
